<div class="page">
    <div class="page__container">
      <h1 class="page__title h2 mb-5">{{ 'menu_reseller_prices' | translate }}</h1>
        <wsb-atlas-button
            class="my-3"
            [label]="'reseller_prices_new'"
            (click)="createRateProfile()">
            {{'reseller_prices_new' | translate }}
        </wsb-atlas-button>
        <div class="my-5">
            <ng-template #modalDelete let-c="close" let-d="dismiss">
                <wsb-modal
                    (primary)="modalDeleteForm()"
                    (dismiss)="d()"
                    cancelButtonEnable="true"
                    title="{{'common_attention' | translate }}"
                    text="{{'reseller_prices_delete_confirm'|translate}}">
                </wsb-modal>
            </ng-template>
            <!-- Main table grid-->
            <wsb-atlas-grid
                #grid
                class="atlas-grid-simplest"
                class="mt-2"
                [columnDefs]="tableColumnDefs"
                [options]="tableGridOptions"
                [@gridIsLoaded]="gridAnimationState"
                [components]="components">
            </wsb-atlas-grid>
        </div>
    </div>
</div>
